import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { ISource } from '@user/store/sources'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { DensityType } from '../../../typings'

type Props = {
  required: boolean
  show: boolean
  name: string
  density: DensityType
}

export function LeadSourceSelect(props: Props) {
  const { required, show, name, density } = props
  const {
    getOptionLabel,
    options,
    initialOption,
    getId,
    isSubmitting,
    showError,
    helperText,
  } = useData({ required, name })
  const { handelChange } = useHandlers({ name })

  return show ? (
    <Box>
      <Select<ISource>
        density={density}
        disabled={isSubmitting}
        required={required}
        error={showError}
        getLabel={getOptionLabel}
        getId={getId}
        items={options}
        onChange={handelChange}
        value={initialOption}
        label={'Lead Source'}
        optionMode={'normal'}
        testId="lead-source-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
